import { Schema as Schema_ } from '@blade/std-lib'

import { DelugeId } from './DelugeId'
import * as UserMinimal from './user-minimal'

import type { ReferralCodeStatus } from '@root/entities/user-short'
import type { AvatarsHost } from '@root/shared/models'

export interface UserShortDto {
  delugeId: string
  username: string
  firstName?: string | undefined
  lastName?: string | undefined
  avatar?: string | undefined
  referralCodeStatus?: ReferralCodeStatus
  isOnline?: boolean
}

export const Schema = Schema_.Struct({
  ...UserMinimal.Schema.fields,
  firstName: Schema_.mutableKey(
    Schema_.UndefinedOrFromOptional(Schema_.String),
  ),
  lastName: Schema_.mutableKey(Schema_.UndefinedOrFromOptional(Schema_.String)),
  referralCodeStatus: Schema_.mutableKey(
    Schema_.optional(
      Schema_.Union([Schema_.Literal('Hyped'), Schema_.Literal('Regular')]),
    ),
  ),
  isOnline: Schema_.mutableKey(Schema_.Boolean),
})

export interface UserShort extends Schema_.Schema.Type<typeof Schema> {}

export const fromDto = (
  dto: UserShortDto,
  avatarsHost: AvatarsHost,
): UserShort => {
  return {
    ...UserMinimal.fromDto(dto, avatarsHost),
    delugeId: DelugeId(dto.delugeId),
    username: dto.username,
    firstName: dto.firstName,
    lastName: dto.lastName,
    referralCodeStatus: dto.referralCodeStatus,
    isOnline: dto.isOnline ?? false,
  }
}

export const someName = (user: UserShort) => {
  if (!user.firstName && !user.lastName) {
    return user.username
  }

  return [user.firstName, user.lastName].filter(Boolean).join(' ')
}

export const fullName = (user: UserShort) =>
  [user.firstName, user.lastName].filter(Boolean).join(' ')

export const initials = (user: UserShort) => {
  if (!user.firstName && !user.lastName) {
    return user.username.at(0)?.toUpperCase() ?? ''
  }

  return [user.firstName?.[0], user.lastName?.[0]]
    .filter(Boolean)
    .join('')
    .toUpperCase()
}
